import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends, toConsumableArray as _toConsumableArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import { ConfirmationModal } from '../components/ConfirmationModal/index.js';
import { i18n } from '../i18n/translate.js';
var _excluded = ["action", "children", "disabled"];

var useConfirmAction = function useConfirmAction(params) {
  var action = params.action,
      _params$children = params.children,
      children = _params$children === void 0 ? i18n.t('Are you sure?') : _params$children,
      disabled = params.disabled,
      props = _objectWithoutProperties(params, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isConfirming = _useState2[0],
      setIsConfirming = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      tempArgs = _useState4[0],
      setTempArgs = _useState4[1];

  var onAction = function onAction() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (disabled) {
      triggerAction(args);
    } else if (!isConfirming) {
      setIsConfirming(true);
      setTempArgs(args);
    }
  };

  var onConfirm = function onConfirm(_, e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    triggerAction(tempArgs);
    onCancel();
  };

  var onCancel = function onCancel(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    setIsConfirming(false);
    setTempArgs(null);
  };

  var triggerAction = function triggerAction(args) {
    if (!Object.hasOwnProperty.call(action, 'prototype')) {
      // cannot use spread operator so just try calling action with the first 5 array arguments (doubt we'd ever have more)
      action(args[0], args[1], args[2], args[3], args[4]);
    } else {
      // we can use the spread operator
      action.apply(void 0, _toConsumableArray(args));
    }
  };

  var confirmationModal = disabled ? null : /*#__PURE__*/React.createElement(ConfirmationModal, _extends({}, props, {
    onConfirm: onConfirm,
    onCancel: onCancel,
    show: isConfirming
  }), children);
  return {
    action: onAction,
    confirmationModal: confirmationModal
  };
};

export { useConfirmAction };